import { useSelector } from 'react-redux';

import { IBscParkingSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { selectBusinessShoppingCenterParkings } from '../../selectors/offerData/offer/selectBusinessShoppingCenterParkings';
import { IState } from '../../store';

export function useBSCParkingsSelector(): IBscParkingSchema[] | null {
  return useSelector<IState, IBscParkingSchema[] | null>(selectBusinessShoppingCenterParkings);
}
